export default __webpack_public_path__ + "static/media/scribble-purple.af3e56ce.png";